import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, options } from '@apexdesigner/schema-tools';

export const slot = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    dayOfWeek: options([
      { value: 'Monday', name: 'Monday' },
      { value: 'Tuesday', name: 'Tuesday' },
      { value: 'Wednesday', name: 'Wednesday' },
      { value: 'Thursday', name: 'Thursday' },
      { value: 'Friday', name: 'Friday' },
      { value: 'Saturday', name: 'Saturday' },
      { value: 'Sunday', name: 'Sunday' },
    ])
      .nullable()
      .optional()
      .presentAs('select')
      .describe('Day Of Week'),

    timeId: z.number().hidden().describe('Foreign key to TermTime'),

    time: belongsTo('TermTime'),

    activityAssignments: hasMany('ActivityAssignment'),

    studentAssignments: hasMany('StudentAssignment'),

    alternateStudentAvailabilities: hasMany('AlternateStudentAvailability'),
  })
  .describe(
    'An assignable unit within a term time, for a specific day of the week.',
  )
  .as('Slot');

export { slot as slotSchema };
